export default {
	"schedulecreate": {
		"pleaseFillAllInformations": "Please fill all information",
		"cancelDispatch": "withdraw schedule",
		"rePlan": "re-plan",
		"batchDispatch": "batch schedule",
		"routeNoStatus": "Status of Dispatch Order",
		"noDispatched": "unavailable",
		"dispatched": "scheduled",
		"closed": "closed",
		"completed": "completed",
		"inTransit": "in transit",
		"routeSource": "Source of Dispatch Order",
		"oppositeAccount": "the other party's tms account",
		"reNotification": "notify again",
		"confirmVehicle": "confirm vehicle",
		"transportServiceDemand": "Surcharge/Discount Items",
		"confirmAndDispatch": "Confirm and Dispatch",
		"acceptJob": "Accept Job",
		"acceptJobTips": "Are you sure you want to accept jobs",
		"dispatchInfo": "scheduling information",
		"tickTips": "the service that has been selected for the dispatch order is as follows",
		"summaryTips": "these services are summarized by the transportation order",
		"noServicesTips": "no service ...",
		"projectMandatoryTips": "product/project is mandatory",
		"clickServiceSelectTips": "click the following transport data below to select the corresponding service",
		"pleaseTips": "please",
		"selectServiceTips": "the service item required for the order",
		"pleaseSelectWaybillTips": "please click a transportation data in the above list",
		"pleaseSelectRouteNo": "please select the dispatch order",
		"pleaseSelectNoDispatchedRouteNo": "you can only select the unscheduled orders",
		"pleaseSelectCarrier": "please select the carrier",
		"pleaseSelectConsignedProduct": "please select shipping products",
		"batchDispatchTips": "batch schedule indication",
		"batchDispatchSuccess": "batch scheduling success",
		"pleaseSpecifyVehicleInfo": "please specify vehicle information",
		"dispatchLetter": "scheduling letter",
		"documentStatusIs": "the document status is",
		"unableToShow": "unable to display",
		"continueRePlan": "if continue to re-plan?",
		"rePlanSuccess": "re-plan successful",
		"pleaseSelectOnlyOne": "please select dispatch order (only one dispatch order can be selected)",
		"cancelDispatchTips": "if continue to revoke the schedule?",
		"cancelDispatchLetter": "withdraw schedule letter",
		"cancelSuccess": "withdraw schedule successfully",
		"pleaseInputcorrectNo": "please enter the right driver phone number!",
		"licenseHasExpired": "this driver's license has expired, whether to use this driver",
		"fleetDisabled": "this fleet has been disabled, whether to use this driver",
		"fleetDisabledTips": "this fleet has been disabled, whether to use this vehicle",
		"vehicleNotAnnualReview": "this vehicle has not been reviewed on time, whether this vehicle is used",
		"vehicleInsuranceExpires": "this vehicle insurance has expired, whether to use this vehicle",
		"cannotSelect1": "this driver has been disabled and cannot be selected",
		"cannotSelect2": "this driver has no points and cannot be chose",
		"cannotSelect3": "this vehicle has been disabled and cannot be selected",
		"ownCar": "own car",
		"individualDriver": "individual driver",
		"carrierSelectTips": "when the carrier chooses an individual driver or has its own driver, you must fill in vehicle information",
		"driverNotNull": "in the list of vehicle information, the driver information cannot be empty",
		"driverPhoneNoNotNull": "in the vehicle information list, the driver's mobile phone number cannot be empty",
		"vehicleTypeNotNull": "in the list of vehicle information, the model cannot be empty",
		"plateNoNotNull": "in the list of vehicle information, the license plate cannot be empty",
		"dispatchSuccess": "successful dispatch",
		"noVehicleInfoTips": "no vehicle information! , do you confirm that you do not require vehicle information?",
		"vehicle": "vehicle",
		"paperStyle": "sample of delivery note",
		"minSizeGtMsg": "the dispatch order includes multiple shipping orders, can not select multiple vehicles!",
		"planInfo": "plan information",
		"pleaseSelectOnlyOne2": "you can only choose one kind of truck model when dispatching multiple orders",
		"addVehicle": "Add a vehicle",
		"vehicleInfoTips": "search vehicle information",
		"searchTrackerTips": "search tracker information",
		"newCapacityDriver": "new driver in capacity pool",
		"newCapacityMobile": "new phone number in capacity pool",
		"newCapacityVehicleType": "new car model in capacity pool",
		"newCapacityPlateNo": "new license plate in capacity pool",
		"newCapacityCertificateNo": "new certificate number in capacity pool",
		"selectDriver": "Select Driver",
		"selectContactNumber": "Select Contact Number",
		"selectActualVehicleType": "Select Actual Vehicle Type",
		"selectVehicleTrailerType": "Select Vehicle Vehicle Type",
		"selectTrailerType": "Select Trailer Type",
		"selectPlateNumber": "Select Plate Number",
		"selectLicenseNumber": "Select License Number",
		"selectProvincialSign": "Select Provincial Sign",
		"live": "real time information",
		"noTemperature": "no temperature",
		"numberData": "articles!",
		"atLeastKeep": "at least",
		"senderCity": "Shipping City/District",
		"receiverCity": "Receive City/District",
		"cancelWaybillTips": "are you sure to cancel the shipping bill?",
		"downloadRouteNo": "download the delivery note",
		"mustPickingUpGoods": "pick-up note is required when picking up the goods",
		"downloadDeliverygoods": "download the pickup note",
		"otherDocument": "other files",
		"clickDownloadTips": "if you need the following orders during your job, please click to download",
		"downloadAll": "package and download all",
		"bill": "order",
		"job": "job",
		"billNo": "order number",
		"download": "download",
		"invalidFileObject": "invalid file object",
		"handoverSheet": "transfer order",
		"noSend": "do not send",
		"send": "send",
		"emailSubject": "email subject",
		"inputEmailSubject": "please enter the mail theme",
		"shortMessageInfo": "sms content",
		"reason": "Reason",
		"truck": "Truck",
		"addTruck": "add a truck",
		"trailer": "Trailer",
		"addTrailer": "add a trailer",
		"subcontractorTruck": "Subcontractor Truck",
		"subcontractorTrailer": "Subcontractor Trailer",
		"trailerTypeRequired": "Trailer Type is required",
		"plateNumberRequired": "Plate Number is required",
		"trailerProvincialSignRequired": "Trailer Provincial Sign is required",
		"driverRequired": "Driver is required",
		"contactNumberRequired": "Contact Number is required",
		"actualVehicleTypeRequired": "Actual Vehicle Type is required",
		"licencseNumberRequired": "License Number is required",
		"truckProvincialSignRequired": "Provincial Sign is required",
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/schedule/schedule.js